FD.PAGE = (function ($, me) {
    'use strict';

    var child = me.PAGE || {};

    /* ========================================================================
     *  vars
     * ========================================================================
    */

   
    var URL_COMMON = '/Common/Common/';
    
    var MODAL_ELEM = '#FD_MODAL';

    var notify;

    /* ========================================================================
     *  tags
     * ========================================================================
    */


    var tag = {
        CONFRIM_EXPIRE_COOKIES: 50
    };


    /* ========================================================================
     *  common methods: used in most views
     * ========================================================================
    */


    //  set common props
    function setCommonProps() {
    }


    //  set top row change: any control inside page controls
    function setTopRowControlChange(data) {

    }


    /*
    * ========================================================================
    * Objects
    * ========================================================================
    */
    

    /*
    * ========================================================================
    * CRUD Functions
    * ========================================================================
    */


    function clearAllPrivateCookies() {
        $(MODAL_ELEM).off().modal('hide');

        var cookies = document.cookie.split("; ");
        for (var c = 0; c < cookies.length; c++) {
            var d = window.location.hostname.split(".");
            while (d.length > 0) {
                var cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
                var p = location.pathname.split('/');
                document.cookie = cookieBase + '/';
                while (p.length > 0) {
                    document.cookie = cookieBase + p.join('/');
                    p.pop();
                };
                d.shift();
            }
        }

        var options = {
            url: URL_COMMON + "ExpireAllCookies",
            callback: afterData,
        };
        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                var notify = new Notify();
                notify.info('All Cookies have been successfully reset to default values');
            }
        }
    }


    /*
    * ========================================================================
    * Partial Views / Returns
    * ========================================================================
    */

    function confrimCookieClear() {
        var options = {
            url: URL_COMMON + "ConfirmDialogue",
            params: {
                message: 'All cookies for Mobile applications (e.g. Audits, IAS, Inventory Tracking, etc.) will be removed and they will be reset to the default values, do you wish to continue',
                dataTag: tag.CONFRIM_EXPIRE_COOKIES
            },
            callback: afterData,
            ishtml: true
        };
        me.AJAX.setAJAX(options);

        function afterData(result) {
            $(MODAL_ELEM).html(result.data).off().on('shown.bs.modal', function () {
                me.CONTROL.setButton(true, MODAL_ELEM);
            }).modal('show');

            me.CONTROL.setButton(true, MODAL_ELEM);
        }
    }


    /*
    * ========================================================================
    * Helper Functions
    * ========================================================================
    */
    
    
    /* ========================================================================
     *  after control event
     * ========================================================================
    */


    function setAfterControlEvent(data) {
        switch (data.tag) {
            case tag.CONFRIM_EXPIRE_COOKIES:
                clearAllPrivateCookies();
                break;
        }
    }


    /* ========================================================================
     *  init
     *  called from docready
     * ========================================================================
    */


    function initPage() {
        setCommonProps();
        notify = notify || new Notify();

        var timer = null;
        var click = 0;
        $('.navbar-brand').on('click', function () {
            clearTimeout(timer);
            click++;
            if (click === 3) {
                confrimCookieClear();
            }
            timer = setTimeout(function () {
                click = 0;
                timer = null;
            }, 5000);
        });
    }


    /* ========================================================================
    *  public methods
    * ========================================================================
   */

    //  after control event
    child.getAfterControlEvent = function (data) {
        setAfterControlEvent(data);
    };


    //  after site view change
    child.getAfterSiteViewChangeEvent = function (val) { };


    //  after pinstate change
    child.getAfterPinStateChangeEvent = function (val) { };


    //  init
    child.init = function () {
        initPage();
    };


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;

}(jQuery, FD));